export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Security First',
      description: 'We prioritize your security above all else. Our applications use industry-leading encryption and security protocols to ensure your data remains protected at all times.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Performance',
      description: 'Optimized for speed and efficiency, our apps are designed to run smoothly without draining your battery or consuming excessive resources on your iOS device.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'User Privacy',
      description: 'Your privacy is paramount. We maintain a strict no-logs policy and never collect, store, or share your personal information with third parties.'
    }
  ];

  return (
    <section className="py-32 bg-[#eef2f7]">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <h2 className="text-5xl lg:text-6xl font-bold text-[#1a2847] text-center mb-20">
          Key Features
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-8">
                <i className={`${feature.icon} text-5xl text-[#3b82f6]`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-[#1a2847] mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}